import { render, staticRenderFns } from "./internal-notes-page-loader.vue?vue&type=template&id=5d74e58c"
import script from "./internal-notes-page-loader.vue?vue&type=script&lang=js"
export * from "./internal-notes-page-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports